<template>
    <div class="tagSelect" :class="{'expanded':expanded,'is-expandable':expandable}">
        <template>
            <div style="position:relative;padding-left:52px;color:#999;top: 4px;line-height: 23px;" v-if="loading">
                <Load></Load>加载中...</div>
        </template>
        <template v-if="!loading">
            <div class="tag" v-for="item in data" :key="item.value" :class="{'selected':value==item.value}" @click="click(item.value)">{{ item.name }}</div>
            <div class="trigger" @click="expanded=!expanded" v-if="expandable">
                <template v-if="!expanded">
                    <i class="el-icon-arrow-down"></i>展开</template>
                <template v-if="expanded">
                    <i class="el-icon-arrow-up"></i>收起</template>
            </div>
            <div class="range" v-if="range">
                <el-input style="width:80px" v-model="range_begin" size="small"></el-input>
                <el-input style="width:80px" v-model="range_end" size="small"></el-input>
                <el-button :type="(this.range_begin||this.range_end)?'primary':''" @click="handleRangeSubmit" size="small" style="height: 32px;">确定</el-button>
            </div>
        </template>

        <ProvinceCity class="area" v-if="area" @onChange="$emit('onChange', $event);"/>

    </div>



</template>
<script>
    import Load from "../global/loading.vue";
    import ProvinceCity from './ProvinceCity'

    export default {
        props: {
            expandable: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            data: {
                type: Array,
                default: []
            },
            range: {
                type: Boolean,
                default: false
            },
            area: {
                type: Boolean,
                default: false
            },
            value: {}
        },
        data() {
            return {
                expanded: false,
                range_begin: "",
                range_end: ""
            };
        },
        mounted() {
            this.handleRange();
        },
        watch: {
            value() {
                this.handleRange();
            }
        },
        components: {
            Load,ProvinceCity
        },
        methods: {
            handleRange() {
                if (this.range) {
                    const v = this.value.split(",");
                    if (v.length == 2) {
                        this.range_begin = v[0];
                        this.range_end = v[1];
                    } else {
                        this.range_begin = "";
                        this.range_end = "";
                    }
                }
            },
            click(v) {
                this.$emit("onChange", v);
            },
            handleRangeSubmit() {
                this.$emit("onChange", this.range_begin + "," + this.range_end);
            }
        }
    };

</script>
<style scoped lang="scss">
    @import "../../../config.scss";

    .tagSelect {
        user-select: none;
        position: relative;
        overflow: hidden;
        max-height: 32px;
        line-height: 32px;
        transition: all 0.3s;
        font-size: 12px;
    }

    .tagSelect.is-expandable {
        padding-right: 24px;
    }

    .tagSelect.expanded {
        transition: all 0.3s;
        max-height: 200px;
    }

    .tag {
        display: inline-block;
        height: 22px;
        cursor: pointer;
        white-space: nowrap;
        padding: 0 8px;
        margin-right: 12px;
        font-size: 12px;
        min-width: 60px;
        color: #626262;
    }

    .tag.selected {
        color: $--color-primary;
    }

    .trigger {
        position: absolute;
        top: 0;
        right: 0;
        color: $--color-primary;
    }

    .range {
        float: right;
        display: flex;
        width: 230px;
        justify-content: space-between;
    }
    .area {
        float: right;
        display: flex;
        width: 230px;
        justify-content: space-between;
    }

    .range-input-begin {
        width: 70px;
    }

    .range-input-begin>>>.el-input__inner {
        border-right: 0 !important;
        border-top-right-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
    }

    .range-input-end {
        width: 140px;
    }

    .range-input-end>>>.el-input__inner {
        border-right: 0 !important;
        border-top-right-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/_widget/TagSelect.vue